<template>
  <div class="page-container">
    <!-- 统计卡片区 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-label">今日转账笔数</span>
          <span class="stat-icon blue">📊</span>
        </div>
        <div class="stat-value">{{ stats.todayCount }}</div>
        <div class="stat-change"><span class="change-text">单日峰值 <b>{{ stats.countPeak }}</b></span></div>
      </div>
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-label">今日转账总额</span>
          <span class="stat-icon green">💰</span>
        </div>
        <div class="stat-value">{{ fmtAmount(stats.todayAmount) }}</div>
        <div class="stat-change"><span class="change-text" :style="{ color: (stats.amountChange || 0) >= 0 ? '#16a34a' : '#dc2626' }">较昨日 {{ (stats.amountChange || 0) >= 0 ? '+' : '' }}{{ stats.amountChange || 0 }}%</span></div>
      </div>
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-label">净兑换户</span>
          <span class="stat-icon orange">👥</span>
        </div>
        <div class="stat-value">{{ stats.users }}</div>
        <div class="stat-change"><span class="change-text">离线提示</span></div>
      </div>
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-label">大额提醒(&gt;1w)</span>
          <span class="stat-icon red">⚠️</span>
        </div>
        <div class="stat-value" style="color:#dc2626;">{{ stats.largeCount }}</div>
        <div class="stat-change"><span class="change-text" style="color:#dc2626;">需要关注</span></div>
      </div>
    </div>

    <!-- 筛选查询区 -->
    <div class="table-wrapper">
      <el-form :inline="true" size="small" class="filter-form">
        <el-form-item label="用户ID">
          <el-input v-model="search.customerNo" placeholder="多个用逗号分隔" clearable style="width:160px;"></el-input>
        </el-form-item>
        <el-form-item label="转出账号">
          <el-input v-model="search.fromAccount" placeholder="转出账号" clearable style="width:130px;"></el-input>
        </el-form-item>
        <el-form-item label="客户组别">
          <el-select v-model="search.customerGroupId" placeholder="全部" clearable style="width:150px;">
            <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="filterExpanded" label="订单号">
          <el-input v-model="search.orderNo" placeholder="订单号" clearable style="width:160px;"></el-input>
        </el-form-item>
        <el-form-item v-if="filterExpanded" label="转入账号">
          <el-input v-model="search.toAccount" placeholder="转入账号" clearable style="width:130px;"></el-input>
        </el-form-item>
        <el-form-item v-if="filterExpanded" label="转出账号类型">
          <el-select v-model="search.fromPlatform" placeholder="全部" clearable style="width:120px;">
            <el-option label="钱包" :value="1"></el-option>
            <el-option label="真实账号" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="filterExpanded" label="转入账号类型">
          <el-select v-model="search.toPlatform" placeholder="全部" clearable style="width:120px;">
            <el-option label="钱包" :value="1"></el-option>
            <el-option label="真实账号" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="filterExpanded" label="提交时间">
          <el-date-picker v-model="search.fromDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" style="width:140px;"></el-date-picker>
          <span class="date-sep">至</span>
          <el-date-picker v-model="search.toDate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" style="width:140px;"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchList">🔍 搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
          <el-button type="text" @click="toggleFilter">{{ filterExpanded ? '收起 ▴' : '展开 ▾' }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 转账列表 -->
    <div class="table-wrapper">
      <div class="table-header">
        <span class="table-title">转账记录</span>
        <div class="table-actions">
          <button class="btn btn-secondary btn-sm" @click="refreshList">🔄 刷新</button>
          <button v-auth="'payment:transferRecord:export'" class="btn btn-primary btn-sm" @click="handleExport">📥 导出</button>
        </div>
      </div>
      <el-table :data="tableData" border v-loading="loading" :row-class-name="rowClass" style="width:100%;">
        <el-table-column label="订单号" width="170">
          <template slot-scope="{row}"><span class="order-no">{{ row.orderNo }}</span></template>
        </el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="100">
          <template slot-scope="{row}"><span class="mono">{{ row.customerNo }}</span></template>
        </el-table-column>
        <el-table-column prop="customerName" label="姓名" width="90">
          <template slot-scope="{row}">{{ row.customerName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="countryName" label="国家" width="90">
          <template slot-scope="{row}">{{ row.countryName || row.countryCode || '--' }}</template>
        </el-table-column>
        <el-table-column prop="customerGroupName" label="客户组别" width="110">
          <template slot-scope="{row}">{{ row.customerGroupName || '--' }}</template>
        </el-table-column>
        <el-table-column label="转出账号类型" width="110">
          <template slot-scope="{row}">{{ row.fromPlatformName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="fromAccount" label="转出账号" width="110">
          <template slot-scope="{row}"><span class="mono">{{ row.fromAccount }}</span></template>
        </el-table-column>
        <el-table-column label="转入账号类型" width="110">
          <template slot-scope="{row}">{{ row.toPlatformName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="toAccount" label="转入账号" width="110">
          <template slot-scope="{row}"><span class="mono">{{ row.toAccount }}</span></template>
        </el-table-column>
        <!-- 金额单位不能写在列头上：一把转账的两条腿币种可能不同（USD 钱包 → USC 美分账号，
             转出 10 USD、到账 1000 USC），列头是整列共用的，写死 (USD) 会标错跨币种的行。
             所以单位跟每个金额走单元格，币种取记录里的 fromCurrency/toCurrency（历史数据为空则不带单位） -->
        <el-table-column label="转出金额" width="130" align="right">
          <template slot-scope="{row}"><span style="color:#cf1322;">-{{ moneyText(row.amount, row.fromCurrency) }}</span></template>
        </el-table-column>
        <el-table-column label="转入金额" width="130" align="right">
          <template slot-scope="{row}"><span style="color:#237804;">+{{ moneyText(receivedAmount(row), row.toCurrency) }}</span></template>
        </el-table-column>
        <el-table-column label="提交时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.submitTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button v-auth="'payment:transferRecord:find'" type="text" size="small" style="color:var(--brand-primary);" @click="openDetail(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;pageNum=1;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" width="600px" :close-on-click-modal="false" title="转账详情">
      <div v-if="detail" class="detail-body">
        <div class="detail-section">
          <div class="detail-title">用户信息</div>
          <div class="detail-grid">
            <div><span class="detail-label">用户ID：</span>{{ detail.customerNo }}</div>
            <div><span class="detail-label">姓名：</span>{{ detail.customerName || '--' }}</div>
            <div><span class="detail-label">国家：</span>{{ detail.countryName || detail.countryCode || '--' }}</div>
            <div><span class="detail-label">客户组别：</span>{{ detail.customerGroupName || '--' }}</div>
          </div>
        </div>
        <div class="detail-section">
          <div class="detail-title">转账信息</div>
          <div class="detail-grid">
            <div><span class="detail-label">订单号：</span><span class="detail-strong">{{ detail.orderNo }}</span></div>
            <div><span class="detail-label">提交时间：</span>{{ fmtDateTime(detail.submitTime) }}</div>
            <div><span class="detail-label">转出账号类型：</span>{{ detail.fromPlatformName || '--' }}</div>
            <div><span class="detail-label">转入账号类型：</span>{{ detail.toPlatformName || '--' }}</div>
            <div><span class="detail-label">转出账号：</span><span class="mono">{{ detail.fromAccount }}</span></div>
            <div><span class="detail-label">转入账号：</span><span class="mono">{{ detail.toAccount }}</span></div>
            <div><span class="detail-label">转出金额：</span><span style="color:#cf1322;font-weight:600;">-{{ moneyText(detail.amount, detail.fromCurrency) }}</span></div>
            <div><span class="detail-label">转入金额：</span><span style="color:#237804;font-weight:600;">+{{ moneyText(receivedAmount(detail), detail.toCurrency) }}</span></div>
            <div v-if="rateText(detail) !== ''"><span class="detail-label">汇率：</span>{{ rateText(detail) }}</div>
          </div>
          <div v-if="detail.isLarge" class="large-tag">⚠️ 大额转账（&gt;1万USD）</div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { transferRecordList, transferRecordStats, transferRecordGroups, transferRecordDetail, transferRecordExport } from '@/api/transferRecord'

export default {
  name: 'TransferRecordList',
  data() {
    return {
      stats: { todayCount: 0, countPeak: 0, todayAmount: 0, amountChange: 0, users: 0, largeCount: 0 },
      search: { customerNo: '', fromAccount: '', customerGroupId: null, orderNo: '', toAccount: '', fromPlatform: null, toPlatform: null, fromDate: null, toDate: null },
      filterExpanded: false,
      groupOptions: [],
      tableData: [], loading: false, total: 0,
      pageNum: 1, pageSize: 15,
      detailVisible: false, detail: null
    }
  },
  created() { this.fetchStats(); this.fetchGroups(); this.fetchList() },
  methods: {
    fetchStats() {
      transferRecordStats().then(res => {
        if (res.code === 0) this.stats = res.result || this.stats
      })
    },
    fetchGroups() {
      transferRecordGroups().then(res => { if (res.code === 0) this.groupOptions = res.result || [] })
    },
    fetchList() {
      this.loading = true
      transferRecordList({ pageNum: this.pageNum, pageSize: this.pageSize, ...this.search }).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      }).finally(() => { this.loading = false })
    },
    searchList() { this.pageNum = 1; this.fetchList() },
    resetSearch() {
      this.search = { customerNo: '', fromAccount: '', customerGroupId: null, orderNo: '', toAccount: '', fromPlatform: null, toPlatform: null, fromDate: null, toDate: null }
      this.pageNum = 1
      this.fetchList()
    },
    toggleFilter() { this.filterExpanded = !this.filterExpanded },
    refreshList() {
      this.pageNum = 1
      this.fetchStats()
      this.fetchList()
      this.$message.success('刷新成功')
    },
    handleExport() {
      transferRecordExport({ ...this.search }).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = '转账记录.xlsx'; a.click()
        URL.revokeObjectURL(url)
      })
    },
    openDetail(row) {
      transferRecordDetail(row.id).then(res => {
        if (res.code === 0) { this.detail = res.result; this.detailVisible = true }
        else this.$message.error(res.message || '获取详情失败')
      })
    },
    rowClass({ row }) { return row.isLarge ? 'large-row' : '' },
    fmtMoney(v) { return v !== null && v !== undefined && v !== '' ? Number(v).toFixed(2) : '0.00' },
    // 金额 + 币种：一笔转账两条腿的币种可能不同（USD 钱包 → USC 美分账号），币种取记录里的
    // fromCurrency/toCurrency；历史数据（改币种/到账金额之前的老记录）这四列为空，只显示金额
    moneyText(v, currency) {
      const text = this.fmtMoney(v)
      return currency ? text + ' ' + currency : text
    },
    // 到账金额：跨币种取换算后的 toAmount（转入账户币种口径），历史数据回退转出金额
    receivedAmount(row) {
      if (!row) return null
      return row.toAmount !== null && row.toAmount !== undefined ? row.toAmount : row.amount
    },
    // 汇率文案：1 USD = 100 USC；同币种、或历史数据（汇率列为空）时返回空串不显示
    rateText(row) {
      if (!row || row.exchangeRate === null || row.exchangeRate === undefined) return ''
      const from = row.fromCurrency || ''
      const to = row.toCurrency || ''
      if (from === '' || to === '' || from === to) return ''
      return '1 ' + from + ' = ' + this.fmtRate(row.exchangeRate) + ' ' + to
    },
    // 去掉 decimal(18,8) 带出来的小数尾巴：100.00000000 → 100
    fmtRate(v) {
      const n = Number(v)
      return isNaN(n) ? String(v) : String(parseFloat(n.toFixed(8)))
    },
    fmtAmount(v) { return v !== null && v !== undefined ? Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00' },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '--' }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.stats-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 16px; }
.stat-card { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.stat-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.stat-label { font-size: 13px; color: #5a6578; }
.stat-icon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 16px; }
.stat-icon.blue { background: #eef4ff; }
.stat-icon.green { background: #ecfdf5; }
.stat-icon.orange { background: #fff7ed; }
.stat-icon.red { background: #fef2f2; }
.stat-value { font-size: 24px; font-weight: 700; color: #1a2236; margin-bottom: 4px; }
.stat-change { font-size: 12px; color: #9ca3af; }
.change-text { font-size: 12px; }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; margin-bottom: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.table-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 500; font-family: inherit; cursor: pointer; transition: all 0.15s; border: 1px solid transparent; white-space: nowrap; }
.btn-primary { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }
.btn-secondary { background: transparent; color: #5a6578; border-color: #e8ecf2; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
.mono { font-family: 'JetBrains Mono', monospace; font-size: 12px; }
.order-no { color: var(--brand-primary); cursor: pointer; font-size: 12px; font-weight: 500; }
.date-sep { margin: 0 4px; color: #9ca3af; }
.detail-body { padding: 0 4px; }
.detail-section { margin-bottom: 20px; }
.detail-title { font-size: 14px; font-weight: 600; color: #1a2236; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #e8ecf2; }
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 16px; font-size: 13px; }
.detail-label { color: #9ca3af; }
.detail-strong { font-weight: 500; }
.large-tag { display: inline-block; margin-top: 12px; padding: 4px 10px; background: #fff1f0; color: #cf1322; border-radius: 4px; font-size: 12px; font-weight: 500; }
</style>

<style>
.el-table .large-row { background: #fff1f0 !important; }
</style>
